export const JSSCategorySelection = theme => ({
    selectRoot: {
        width: '12rem',
    },
    menuRoot: {
        maxHeight: '20rem',
    }
});